<template>
  <div class="setting">
    <div v-if="show11">
      <div class="canvas" ref="courseInfo">
        <div>
          <img :src="imgUrl " class="postimg" crossorigin="anonymous" />
          <div class="info">
            <div class="flex aic">
              <!-- <img :src="user.avatarPath | getavatar" class="avater" /> -->
              <van-image
                :src="user.avatarPath | getavatar"
                class="avater"
                round
              >
                <template v-slot:error>
                  <img
                    src="../../assets/img/avater.png"
                    class="avater"
                    style="margin: 0"
                  />
                </template>
              </van-image>
              <span class="f1010 f12 mr-10 ml-64">{{ user.alias?user.alias:user.nickName }}</span>
              <span class="f8 cl99" v-if="checked[0]">{{
                user.virtualJob
              }}</span>
            </div>
            <div class="flex jc-sb mt-10">
              <div class="f8 cl99">
                <div class="mt-5 flex aic" v-if="checked[1] || checked[2]">
                  <img src="../../assets/img/poster/1.png" class="logo2" />
                  <span v-if="checked[1]"
                    >{{ user && user.dept.name |getname}}
                  </span>
                  <span v-if="checked[1] && checked[2]" class="ml-5 mr-5">
                    |
                  </span>
                  <span v-if="checked[2]">
                    从业{{ user.workingSeniority }}</span
                  >
                </div>
                <div class="mt-5 flex aic" v-if="checked[3]">
                  <img src="../../assets/img/poster/2.png" class="logo2" />
                  <span>{{ user.phone }}</span>
                </div>
              </div>
              <div>
                <div class="bgb">
                  <img :src="recode" alt="" />
                </div>
                <div class="msg">扫一扫了解我</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bottombar">
        <div
          class="flex jc-sb aic f18 f1010"
          style="font-family: SourceHanSansSC-bold"
        >
          <div>{{ postermsg.name }}</div>
          <div class="typebtn" v-if="postermsg.categoryName">{{ postermsg.categoryName }}</div>
        </div>
        <van-divider />
        <div class="flex jc-sb" style="flex-shrink: 0; flex-wrap: wrap">
          <div
            class="radios flex aic mt-25"
            v-for="(item, index) in arr"
            :key="index"
            @click="getchecked(index)"
          >
            <div class="radio" :class="{ unchecked: !checked[index] }">
              <van-icon name="success" v-if="checked[index]" />
            </div>
            <div>{{ item }}</div>
          </div>
        </div>
        <van-divider />
        <div class="blue_btn" @click="toImage">生成海报</div>
      </div>
    </div>
    <!-- <img :src="dataURL" alt="" class="tuimg" v-else/> -->
    <van-image
      style="width: 100vw"
      :src="dataUrl"
      v-else
      fit="fill"
    ></van-image>
    <!-- <a :href="dataURL"> 下载</a> -->
    <canvas id="canvas" style="display: none"></canvas>
  </div>
</template>

<script>
import { getqrcode, adduserPoster } from "@/api/poster";
import { userinfo } from "../../api/apis";
import { loading } from "../../utils/index";
import html2canvas from "html2canvas";
export default {
  data() {
    return {
      arr: ["隐藏职位信息", "隐藏所在公司", "隐藏从业年限", "隐藏手机号"],
      checked: [true, true, true, true], //海报选项
      dataURL: "", //生成海报
      show11: true, //展示海报
      recode: "", //二维码
      user: "", //用户信息
      imgUrl: "", //海报封面
      poster: "", //生成海报信息
      postermsg: "", //封面信息
      canvas: "",
    };
  },
  methods: {
    getchecked(inx) {
      if (this.checked[inx]) {
        this.$set(this.checked, inx, false);
      } else {
        this.$set(this.checked, inx, true);
      }
    },
    toImage() {
      loading(true);
      this.drawFxDetialCanvas(this.canvas);
    },
    getqr() {
      getqrcode().then((res) => {
        console.log(res);
        this.recode = res;
      });
    },
    getinfo() {
      userinfo().then((res) => {
        this.poster.userId = res.id;
        this.user = res;
      });
    },
    addPoster() {
      adduserPoster(this.poster).then((res) => {
        this.Toast({message:"长按保存图片",duration:2000})
      });
    },
    saveFile(data, filename) {
      var save_link = document.createElementNS(
        "http://www.w3.org/1999/xhtml",
        "a"
      );
      save_link.href = data;
      save_link.download = filename;
      var event = document.createEvent("MouseEvents");
      event.initMouseEvent(
        "click",
        true,
        false,
        window,
        0,
        0,
        0,
        0,
        0,
        false,
        false,
        false,
        false,
        0,
        null
      );
      save_link.dispatchEvent(event);
    },
    getCanvas() {
      let canvas = document.getElementById("canvas");
      canvas.width = 750;
      canvas.height = 1300;
      return canvas;
    },
    // 获取图形上下文context
    getCxt(canvas) {
      return canvas.getContext("2d");
    },
    loadImg(url,type) {
      return new Promise((resolve, reject) => {
        let img = new Image();
        // 允许跨域
        img.setAttribute("crossOrigin", "Anonymous");
        img.onload = () => {
          resolve(img);
        };
        img.onerror = () => {
          this.Toast(type==3?'头像无效，请重新上传头像后再创建海报':"图片下载失败，请联系管理员");
          reject()
        };
        img.src = url;
      });
    },
    // 加载本地图片
    onLoadImage(canvas, src) {
      return new Promise((resolve, reject) => {
        let img = new Image();
        img.src = src;
        img.onload = () => {
          resolve(img);
        };
        img.onerror = (e) => {
          console.log(e)
          //   uni.hideLoading();
          reject("");
        };
        img.src = src;
      });
    },
    // 圆形
    circleImg(ctx, img, x, y, w, h) {
      ctx.beginPath();
      ctx.arc(x + w / 2, y + h / 2, w / 2, 0, Math.PI * 2, false);
      ctx.closePath();
      // 裁剪
      ctx.clip();
      ctx.drawImage(img, x, y, w, h);
      ctx.restore();
    },
    async drawFxDetialCanvas(canvas) {
      const ctx = canvas.getContext("2d", { antialias: true });
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, 750, 1300);
      //   绘制背景图片
      let bgImg = await this.loadImg(this.imgUrl,1);
      //   二维码
      let qrcode = await this.loadImg(this.recode,2);
      // 开启跨域支持

      ctx.drawImage(bgImg, 0, 0, 750, 1040);

      //  绘画名字
      ctx.font = '32px "SourceHanSansSC-bold"';
      ctx.fillStyle = "#101010";
      ctx.textBaseline = "top";
      let name=this.user.alias?this.user.alias:this.user.nickName
      ctx.fillText(name, 168, 1051);
      ctx.closePath();

      // 职位
      if (this.checked[0]) {
        ctx.font = '20px "SourceHanSansSC-regular"';
        ctx.fillStyle = "#999FA4";
        ctx.textBaseline = "top";
        ctx.fillText(this.user.virtualJob, 341, 1064);
        ctx.closePath();
      }
      if (this.checked[1] || this.checked[2]) {
        // 图标
        let data=''
        if(this.checked[1]&&this.checked[2]){
          data=this.getname(this.user.dept.name)+' | '+'从业' + this.user.workingSeniority
        }else if(this.checked[1]){
          data=this.getname(this.user.dept.name)
        }else{
          data='从业' + this.user.workingSeniority
        }
        let logo1 = new Image();
        logo1.crossOrigin = "*";

        logo1.src = require("../../assets/img/poster/1.png");
        logo1.onload = function () {
          ctx.drawImage(logo1, 46, 1165, 22, 22);
        };
        ctx.font = '22px "SourceHanSansSC-bold"';
        ctx.fillStyle = "#999FA4";
        ctx.textBaseline = "top";
        ctx.fillText(data, 97, 1165);
        ctx.closePath();
      }

      if (this.checked[3]) {
        let logo2 = new Image();
        logo2.crossOrigin = "*";

        logo2.src = require("../../assets/img/poster/2.png");
        logo2.onload = function () {
          ctx.drawImage(logo2, 46, 1213, 22, 22);
        };
        // 手机号
        ctx.font = '22px "SourceHanSansSC-bold"';
        ctx.fillStyle = "#999FA4";
        ctx.textBaseline = "top";
        ctx.fillText(this.user.phone , 97, 1213);
        ctx.closePath();
      }

      //   右侧蓝框
      let logo3 = new Image();
      logo3.src = require("../../assets/img/poster/3.png");
      logo3.crossOrigin = "*";
      logo3.onload = function () {
        ctx.drawImage(logo3, 582, 1110, 128, 128);
        ctx.drawImage(qrcode, 592, 1120, 108, 108);
      };


      // 画头像
      ctx.beginPath();
      ctx.arc(85, 1053, 65, Math.PI * 1, Math.PI * 2, false);
      ctx.fillStyle = "#ffffff"; //填充颜色,默认是黑色
      ctx.fill(); //画实心圆

      ctx.closePath();
      ctx.save();
      let avater = this.getavatar(this.user.avatarPath);
      avater = await this.loadImg(avater,3).catch(()=>avater =this.loadImg('http://zlx-resources.oss-cn-beijing.aliyuncs.com/avatar/avater-20210305035914803.png',3))
      await this.circleImg(ctx, avater, 85 - 53, 1053 - 53, 53 * 2, 53 * 2);
      setTimeout(() => {
        let cvs = document.getElementById("canvas");
        var dataUrl = cvs.toDataURL("image/jpeg", 1.0);
        console.log(dataUrl);
        this.dataUrl = dataUrl;
        this.show11 = false;
        
         this.addPoster();
        loading(false);
        
      }, 800);
    },
    getavatar(val) {
      // console.log(val)
      if (val && val.indexOf("http") == -1) {
        if (val.indexOf("/avatar/") == -1) {
          return process.env.VUE_APP_URL + "/avatar/" + val;
        } else {
          return process.env.VUE_APP_URL + val.split("zlxadmin")[1];
        }
      } else {
        return val;
      }
    },
    getname(val){
      if(val=='中联信总部'){
        return val
      }else{
        return '中联信'+val
      }
    }
  },
  async mounted() {
    let { imgUrl, id } = this.$route.query;
    this.postermsg = this.$route.query;
    this.imgUrl = imgUrl + "?" + new Date().getTime();
    if (!imgUrl) {
      this.$router.go(-1);
    }
    await this.getinfo();

    let poster = {
      posterUrl: imgUrl,
      posterId: id,
      userId: this.userid,
    };
    console.log(this.user);
    this.poster = poster;
    this.getqr();
    this.canvas = await this.getCanvas();
  },
  filters:{
    getname(val){
      if(val=='中联信总部'){
        return val
      }else{
        return '中联信'+val
      }
      
    }
  }
};
</script>

<style lang="less" scoped>
.setting {
  width: 100%;
  // .wh{
  //   width: 231px;
  //   height: 412px;
  // }
  .canvas {
    width: 231px;
    margin: 19px auto 17px;
    background: #fff;
    border-radius: 0px 0px 5px 5px;
    height: 412px;
  }
  .postimg {
    width: 231px;
    height: 320px;
  }
  .info {
    width: 100%;
    height: 92px;
    // line-height: 20px;
    border-radius: 0px 0px 5px 5px;
    text-align: center;
    border: 1px solid rgba(255, 255, 255, 100);
    background: #fff;
    .avater {
      width: 38px;
      height: 38px;
      border-radius: 50%;
      border: 3px solid #fff;
      margin-top: -7px;
      margin-left: 10px;
      margin-right: 12px;
      z-index: 999;
      position: absolute;
    }
    .logo1 {
      width: 10px;
      height: 10px;
      margin-right: 9px;
      margin-left: 14px;
    }
    .logo2 {
      width: 14px;
      height: 14px;
      margin-right: 8px;
      margin-left: 11px;
    }
    .bgb {
      width: 38px;
      height: 38px;
      background-image: url("../../assets/img/poster/3.png");
      background-size: 100% 100%;
      margin-right: 13px;
      padding: 2px;
      img {
        width: 34px;
        height: 34px;
      }
    }
    .msg {
      color: #000;
      font-size: 7px;
      margin-top: 3px;
    }
  }
  .bottombar {
    width: 100%;
    // height: 255px;
    border: 1px solid rgba(255, 255, 255, 100);
    background: #fff;
    // position: fixed;
    // left: 0;
    // bottom: 0;
    padding: 12px 20px 27px 16px;
    .typebtn {
      // width: 51px;
      padding: 0 5px;
      height: 18px;
      line-height: 18px;
      border-radius: 9px;
      color: rgba(93, 199, 185, 100);
      font-size: 9px;
      text-align: center;
      font-family: Roboto;
      border: 1px solid rgba(93, 199, 185, 100);
      box-sizing: border-box;
    }
    .radios {
      color: rgba(16, 16, 16, 100);
      font-size: 13px;
      text-align: left;
      font-family: SourceHanSansSC-regular;
      .radio {
        width: 14px;
        height: 14px;
        background: #4094f4;
        color: #fff;
        font-size: 12px;
        line-height: 14px;
        text-align: center;
        margin-right: 5px;
      }
      .unchecked {
        background: #fff;
        border: 1px solid #adadad;
        box-sizing: border-box;
      }
    }
    .blue_btn {
      width: 338px;
      height: 44px;
      line-height: 44px;
      border-radius: 100px;
      background-color: rgba(64, 148, 244, 100);
      color: rgba(255, 255, 255, 100);
      font-size: 14px;
      text-align: center;
      font-family: Roboto;
      border: 1px solid rgba(255, 255, 255, 100);
      margin: 0 auto;
    }
  }
  .tuimg {
    width: 100vw;
    // height: 100vh;
  }
  .ml-64 {
    margin-left: 58px;
  }
}
</style>